var exports = {
  "Qs": "CameraPreviewModal.module__content___MGpmYU",
  "Wc": "CameraPreviewModal.module__backgroundSection___MGpmYU",
  "Pz": "CameraPreviewModal.module__backgroundLabel___MGpmYU",
  "Ip": "CameraPreviewModal.module__effectStrengthSlider___MGpmYU",
  "TM": "CameraPreviewModal.module__effectStrengthLabelRow___MGpmYU",
  "dI": "CameraPreviewModal.module__effectStrengthLabel___MGpmYU",
  "j": "CameraPreviewModal.module__videoContainer___MGpmYU",
  "qr": "CameraPreviewModal.module__footer___MGpmYU",
  "wu": "CameraPreviewModal.module__footerStart___MGpmYU",
  "Dr": "CameraPreviewModal.module__footerMirrorSwitch___MGpmYU",
  "Ki": "CameraPreviewModal.module__video___MGpmYU",
  "Lw": "CameraPreviewModal.module__overlay___MGpmYU",
  "um": "CameraPreviewModal.module__overlayText___MGpmYU",
  "nU": "CameraPreviewModal.module__overlayTextMedium___MGpmYU",
  "$q": "CameraPreviewModal.module__errorOverlay___MGpmYU",
  "kc": "CameraPreviewModal.module__errorText___MGpmYU",
  "JU": "CameraPreviewModal.module__errorTitle___MGpmYU",
  "m2": "CameraPreviewModal.module__errorDetail___MGpmYU",
};

module.exports = exports;
